import { lazyGetUnseenItemsCount } from "owa-activity-feed";
import { setShellButtonCustomBadgeCount, setShellButtonCustomBadgeColors, setShellButtonCustomTooltip, } from "owa-suite-header-apis";
const BADGE_COLOR_RED = "#D13438";
import loc from "owa-localize";
import { logUsage } from "owa-analytics";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
const OwaActivityFeedButtonID: string = "owaActivityFeedButton";
import { addisonNotifNewItemsFmt as strings_addisonNotifNewItemsFmt } from "./updateNotificationsBadge.locstring.json";

export default function updateNotificationsBadge(): void {
    // TODO - consolidate the following code with the code in OwaSuiteHeader.tsx
    
    (lazyGetUnseenItemsCount.importAndExecute() as Promise<number>).then(unseenItemsCount => {
        const showUnseenItemsBadge = unseenItemsCount > 0;
        if (showUnseenItemsBadge) {
            logUsage("ActivityFeed_UnreadBadgeCount", getModuleContextMailboxInfo(), {
                badgeCount: unseenItemsCount,
            });
        }
        setShellButtonCustomBadgeCount(OwaActivityFeedButtonID, unseenItemsCount);
        const bellTooltip = showUnseenItemsBadge ? loc(strings_addisonNotifNewItemsFmt) : ""; // Empty string = default tooltip (name of the pane)
        setShellButtonCustomTooltip(OwaActivityFeedButtonID, bellTooltip);
        
        const redBadgeColor = {
            badgeColor: BADGE_COLOR_RED,
            badgeHoverColor: BADGE_COLOR_RED,
            badgeFontColor: "white",
            badgeFontHoverColor: "white",
        };
        setShellButtonCustomBadgeColors(OwaActivityFeedButtonID, redBadgeColor);
    });
}
